import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navigation_visibility: false,
    toast_visibility: localStorage.getItem('toast_visibility')
      ? JSON.parse(localStorage.getItem('toast_visibility'))
      : null,
    toast_message: localStorage.getItem('toast_message') ? JSON.parse(localStorage.getItem('toast_message')) : null,
    toast_type: localStorage.getItem('toast_type') ? JSON.parse(localStorage.getItem('toast_type')) : null,
    toast_icon: localStorage.getItem('toast_icon') ? JSON.parse(localStorage.getItem('toast_icon')) : null,
    show_all_dates: false,
    forms: [],
    forms_valid: false,
  },
  mutations: {
    set_navigation_visibility(state, value) {
      state.navigation_visibility = value;
    },
    set_toast_visibility(state, value) {
      state.toast_visibility = value;
      localStorage.setItem('toast_visibility', JSON.stringify(value));
    },
    set_toast_message(state, value) {
      state.toast_message = value;
      localStorage.setItem('toast_message', JSON.stringify(value));
    },
    set_toast_type(state, value) {
      state.toast_type = value;
      localStorage.setItem('toast_type', JSON.stringify(value));
    },
    set_toast_icon(state, value) {
      state.toast_icon = value;
      localStorage.setItem('toast_icon', JSON.stringify(value));
    },
    toggle_show_all_dates(state, value) {
      state.show_all_dates = value;
    },
    addForm(state, data) {
      state.forms.push(data);
    },
  },
  actions: {
    toggle_show_all_dates(context, value) {
      context.commit('toggle_show_all_dates', value);
    },
    validate_forms({ state }) {
      state.forms_valid = false;
      state.forms.forEach((form) => {
        if (form.validate().errors().any()) {
          state.forms_valid = true;
        }
      });
    },
  },
});
